/* eslint-disable @typescript-eslint/no-explicit-any */

import type {Style} from '@sail/engine';

const getDeprecationMessage = (key: string, fallback?: string) => {
  const message = `Sail property "${key}" is deprecated. Please use ${
    fallback ? `"${fallback}"` : 'native CSS properties'
  } instead.`;

  return message;
};

export const deprecate = (
  key: string,
  plugin?: Style.Plugin,
  fallback?: string,
): Style.Plugin => {
  if (process.env.NODE_ENV !== 'production' || !plugin) {
    return () => {
      throw new Error(getDeprecationMessage(key, fallback));
    };
  }

  return plugin;
};

/// Note: The idea is to extend this flag to other properties rather than just height in the future.
export const excludeUndefinedValuesForHeightProp = !!(
  typeof window !== 'undefined' &&
  // eslint-disable-next-line @stripe-internal/stripe/no-window-preloaded-access
  (window as any)?.PRELOADED?.flags
    ?.enable_sail_engine_excluded_undefined_values_for_height_prop
);
